import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';
import { failStatus, successStatus } from '../../../../../../../core/models/request-status.model';
import { PageStatusRequest } from './content-page-grid.model';

@Injectable({
  providedIn: 'root',
})
export class ContentPageGridAdapter {
  constructor(
    private http: HttpClient,
    private translationService: TranslationService,
    private occEndPointService: OccEndpointsService,
  ) {}

  getPage(pageIDorLabel: string): Observable<PageStatusRequest> {
    const url = this.occEndPointService.buildUrl('customPage', {
      urlParams: { id: pageIDorLabel },
    });

    return this.http.get(url).pipe(
      map(page => {
        return {
          page,
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            ...failStatus,
            message: textError,
          })),
        );
      }),
    );
  }
}
